// extracted by mini-css-extract-plugin
export default {"panelHeader":"PanelHeader_panelHeader__AiF+e","menuList":"PanelHeader_menuList__OVfuh","menuItem":"PanelHeader_menuItem__+Xuvm","menuIcon":"PanelHeader_menuIcon__koL4F"};